const danhSachCanBo = state => state.danhSachCanBo;
const danhSachLanhDao = state => state.danhSachLanhDao;
const danhSachMenu = state => state.danhSachMenu;
const canBo = state => state.canBo;
const anhDaiDien_FilePath = state => state.anhDaiDien_FilePath;

export default {
  danhSachCanBo,
  danhSachLanhDao,
  danhSachMenu,
  canBo,
  anhDaiDien_FilePath,
};
